import { Text, View } from '@react-pdf/renderer';
import styles from '../pro-report-pdf-styles';

interface DestinationPortProps {
  portName?: string;
  portUnlocode?: string;
  portCountry?: string;
}

function DestinationPort({
  portName,
  portUnlocode,
  portCountry,
}: DestinationPortProps) {
  const portParts = [];
  if (portName) portParts.push(portName);
  if (portCountry) portParts.push(portCountry);
  const portInfo = portParts.length > 0 ? `${portParts.join(', ')} ` : '';
  const destinationPortText = `${portInfo}(UNLOCODE: ${portUnlocode})`;
  return (
    <View style={styles.section}>
      <View style={styles.tableRow}>
        <Text style={styles.tableHeaderReducedWidth}>Destination port:</Text>
        <Text
          style={{
            ...styles.tableHeaderReducedWidthNoFill,
            borderLeftWidth: 0,
          }}
        >
          {portName || portUnlocode ? destinationPortText : 'Not specified'}
        </Text>
      </View>
    </View>
  );
}

DestinationPort.defaultProps = {
  portName: '',
  portUnlocode: '',
  portCountry: '',
};

export default DestinationPort;
